import { useSelector } from 'react-redux';

export const selectUnreadCount = state => state?.myNotifications?.unreadCount;
const selectMyNotificaticationsEnabled = state => state?.brand?.myNotificationsEnabled;
const selectIsInGame = state => state?.realityCheck?.isInGame;

const NotificationsNotifier = ({ small }) => {
	const myNotificationsEnabled = useSelector(selectMyNotificaticationsEnabled);
	const unreadNotificationCount = useSelector(selectUnreadCount);
	const isInGame = useSelector(selectIsInGame);

	const templateClassNames = 'galaxy';
	const screenSizeClassname = small ? 'small' : '';
	const inGameClassname = isInGame ? 'ingame' : '';
	return (
		myNotificationsEnabled &&
		unreadNotificationCount > 0 && (
			<span
				className={`header-unread-message-notifier ${templateClassNames} ${screenSizeClassname} ${inGameClassname}`}
			>
				{unreadNotificationCount > 9 ? '9+' : unreadNotificationCount}
			</span>
		)
	);
};

export default NotificationsNotifier;
